export default function BeerFinderAuthScreen({ t, onLogin }) {
  return (
    <div className="beerFinder">
      <div className="beerFinderCard beerFinderStart">
        <div className="beerFinderEmoji">🍺</div>

        <h2>{t("auth_title")}</h2>

        <p>{t("auth_subtitle")}</p>

        <button
          className="beerFinderPrimaryBtn"
          type="button"
          onClick={onLogin}
        >
          {t("auth_login")}
        </button>
      </div>
    </div>
  );
}